<h2 mat-dialog-title>{{ isNew ? "New Flattened Column" : "Edit Flattened Column" }}</h2>
<div mat-dialog-content>
  <div class="row">
    <div class="col-md-4"><mat-form-field class="full-width"><mat-label>Parent table (where it appears)</mat-label>
      <mat-select [(value)]="result.parentTableId" [disabled]="pathIds.length > 0"><mat-option *ngFor="let t of data.tables" [value]="t.admTableId">{{ t.tableName }}</mat-option></mat-select></mat-form-field></div>
    <div class="col-md-4"><mat-form-field class="full-width"><mat-label>Output name</mat-label><input matInput [(ngModel)]="result.outputName" name="fon" placeholder="e.g. department_name" /></mat-form-field></div>
    <div class="col-md-4"><mat-form-field class="full-width"><mat-label>Display name</mat-label><input matInput [(ngModel)]="result.displayName" name="fdn" /></mat-form-field></div>
  </div>
  <div class="row">
    <div class="col-md-4"><mat-form-field class="full-width"><mat-label>Field group (on the parent table)</mat-label>
      <mat-select [(value)]="result.admFieldGroupId" [disabled]="result.ungrouped" (selectionChange)="result.ungrouped = false">
        <mat-option [value]="null">(default from source table)</mat-option>
        <mat-option *ngFor="let g of fieldGroupsOf(result.parentTableId)" [value]="g.admFieldGroupId">{{ g.name }}</mat-option>
      </mat-select></mat-form-field></div>
    <div class="col-md-4" style="margin-top: 10px">
      <mat-checkbox [(ngModel)]="result.ungrouped" name="fugr">Leave ungrouped</mat-checkbox>
    </div>
  </div>

  <div><b>Path</b>
    <span *ngIf="pathIds.length === 0" class="text-muted"> (choose the first step below)</span>
    <ol style="margin: 6px 0">
      <li *ngFor="let id of pathIds">{{ pathLabel('' + id) }}</li>
    </ol>
  </div>
  <div class="row">
    <div class="col-md-8">
      <mat-form-field class="full-width"><mat-label>Add next step</mat-label>
        <mat-select (selectionChange)="addPathStep($event.value)">
          <mat-option *ngFor="let r of nextPathRelationships" [value]="r.admRelationshipId">{{ relationshipLabel(r) }}</mat-option>
        </mat-select></mat-form-field>
    </div>
    <div class="col-md-4" style="margin-top: 10px"><button mat-raised-button class="piButton" (click)="removeLastPathStep()" [disabled]="pathIds.length === 0">Remove last step</button></div>
  </div>
  <div class="row" *ngIf="pathEndTableId !== null">
    <div class="col-md-8">
      <mat-form-field class="full-width"><mat-label>Value from column of {{ tableName(pathEndTableId) }}</mat-label>
        <mat-select [(value)]="result.sourceColumnId" (selectionChange)="onSourceColumnChange($event.value)">
          <mat-option *ngFor="let c of columnsOf(pathEndTableId)" [value]="c.admTableColumnId">{{ c.outputName || c.columnName }} ({{ c.warehouseType || "unsupported" }})</mat-option>
        </mat-select></mat-form-field>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-raised-button class="piButton" (click)="onSave()" [disabled]="pathIds.length === 0 || !result.sourceColumnId || !result.outputName">Save flattened column</button>&nbsp;
  <button mat-raised-button class="piButton" (click)="onCancelClick()">Cancel</button>&nbsp;
  <button mat-raised-button class="piButton" *ngIf="!isNew" (click)="onToggleRetired()">{{ data.retired ? "Restore" : "Retire" }}</button>&nbsp;
  <button mat-raised-button class="piButton" *ngIf="!isNew" (click)="onDelete()">Delete</button>
</div>
